var _circle, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSurveyBerhasil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 65,
    r: 65,
    fill: "url(#paint0_linear_415_2752)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_415_2752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.2951 22.0207L58.7815 26.9814C59.3272 29.0179 58.1074 31.1306 56.0709 31.6762C54.0344 32.2219 51.9217 31.0022 51.376 28.9657L32.8625 33.9264C28.7895 35.0177 26.35 39.2431 27.4413 43.3161L43.3155 102.56C44.4069 106.633 48.6323 109.072 52.7053 107.981L97.1378 96.075C101.211 94.9837 103.65 90.7583 102.559 86.6853L86.6848 27.4418C85.5934 23.3689 81.368 20.9293 77.2951 22.0207Z",
    fill: "url(#paint1_linear_415_2752)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6503 90.521L51.2177 102.427C50.1069 102.724 49.1679 102.182 48.8703 101.071L32.9961 41.8279C32.6984 40.7171 33.2405 39.7781 34.3514 39.4805L78.7839 27.5748C79.8948 27.2772 80.8337 27.8193 81.1314 28.9301L97.0056 88.1736C97.3033 89.2844 96.7611 90.2233 95.6503 90.521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.781 26.9812C59.3266 29.0177 58.1069 31.1304 56.0704 31.6761C54.0339 32.2218 51.9212 31.002 51.3755 28.9655L38.416 32.438L40.4003 39.8434C40.946 41.8799 43.0587 43.0997 45.0952 42.554L71.0142 35.609C73.0507 35.0633 74.2704 32.9507 73.7247 30.9142L71.7405 23.5087L58.781 26.9812Z",
    fill: "url(#paint2_linear_415_2752)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0929 20.568C49.0199 21.6593 46.5804 25.8847 47.6718 29.9577C48.7631 34.0307 52.9885 36.4702 57.0615 35.3788C61.1345 34.2875 63.574 30.0621 62.4826 25.9891C61.3913 21.9161 57.1659 19.4766 53.0929 20.568ZM56.0694 31.6761C54.0329 32.2218 51.9202 31.002 51.3745 28.9655C50.8288 26.929 52.0486 24.8164 54.0851 24.2707C56.1216 23.725 58.2343 24.9448 58.7799 26.9813C59.3256 29.0178 58.1058 31.1304 56.0694 31.6761Z",
    fill: "url(#paint3_linear_415_2752)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4616 59.0834L79.6779 53.1306L80.6701 56.8333L58.4538 62.7862L57.4616 59.0834ZM45.8574 60.2085L53.2629 58.2242L55.2471 65.6296L47.8417 67.6139L45.8574 60.2085Z",
    fill: "url(#paint4_linear_415_2752)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9265 75.7455L84.1428 69.7927L85.1349 73.4954L62.9186 79.4483L61.9265 75.7455ZM50.3223 76.8706L57.7277 74.8863L59.712 82.2918L52.3065 84.276L50.3223 76.8706Z",
    fill: "url(#paint5_linear_415_2752)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_415_2752)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.491 64.2219C102.86 63.9996 103.301 63.9288 103.721 64.0245C104.141 64.1203 104.508 64.375 104.744 64.7352L106.394 67.2519C106.61 67.5808 106.702 67.9753 106.655 68.3657C106.607 68.7561 106.424 69.1172 106.136 69.3852L106.131 69.3919L106.107 69.4135L106.012 69.5019L105.637 69.8602C103.562 71.8729 101.55 73.9494 99.604 76.0869C95.9424 80.1135 91.594 85.3835 88.6674 90.4969C87.8507 91.9235 85.8557 92.2302 84.6724 90.9985L73.864 79.7685C73.7092 79.6075 73.5882 79.417 73.5084 79.2084C73.4286 78.9997 73.3916 78.7771 73.3995 78.5539C73.4074 78.3306 73.4602 78.1112 73.5546 77.9087C73.649 77.7062 73.7831 77.5248 73.949 77.3752L77.2157 74.4285C77.5028 74.1697 77.8709 74.0187 78.257 74.0014C78.6431 73.9841 79.0233 74.1015 79.3324 74.3335L84.8474 78.4685C93.4607 69.9735 98.3474 66.7135 102.491 64.2219Z",
    fill: "url(#paint6_linear_415_2752)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_415_2752",
    x1: 0.00000245396,
    y1: -12.6389,
    x2: 96.4167,
    y2: 118.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749499,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_415_2752",
    x1: 29.1198,
    y1: 37.3448,
    x2: 101.847,
    y2: 92.3976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E90111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976066,
    stopColor: "#A8010D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_415_2752",
    x1: 38.1314,
    y1: 32.3416,
    x2: 72.0174,
    y2: 35.1676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6000D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615636,
    stopColor: "#E60011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842641,
    stopColor: "#A7000C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60011"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_415_2752",
    x1: 47.6857,
    y1: 23.5697,
    x2: 61.0631,
    y2: 32.9262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E8E8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_415_2752",
    x1: 62.5196,
    y1: 55.7439,
    x2: 64.5039,
    y2: 63.1493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_415_2752",
    x1: 66.9845,
    y1: 72.406,
    x2: 68.9688,
    y2: 79.8114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_415_2752",
    x1: 90.0326,
    y1: 63.9829,
    x2: 90.0326,
    y2: 91.7674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2FC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AB01F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_415_2752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    fill: "white",
    transform: "translate(8.66211 32.4736) rotate(-15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_415_2752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(70 59)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSurveyBerhasil);
export default __webpack_public_path__ + "static/media/ic-survey-berhasil.3f2685409ee26216e9d2cc9da08a5006.svg";
export { ForwardRef as ReactComponent };